export default class navigation {
  static async push(url, history) {
    if (window.location.pathname.indexOf('/internal/account') >= 0 && url.indexOf('/internal/account') >= 0) {
      history.push(url);
    } else {
      window.location.assign(url);
    }
  }

  static async replace(url, history) {
    if (window.location.pathname.indexOf('/internal/account') >= 0 && url.indexOf('/internal/account') >= 0) {
      history.replace(url);
    } else {
      window.location.assign(url);
    }
  }
}
